module.exports = __webpack_public_path__ + "img/News_item_15.e2622f06.jpg";